import styled from 'styled-components';

export const Wrapper = styled.div`
background: linear-gradient(${props=>props.colorone},${props=>props.colortwo});
margin: 15px auto;
border-radius: 30px;
padding: 5px 0px 5px 5px;
width: 95%;



`;

export const Content = styled.div`



`;

export const Text = styled.div`
    text-align: center;
    font-family: sans-serif;

`;